export enum YieldState {
  Initial = 'initial',
  InitialApproving = 'initial:approving',
  InitialRejected = 'initial:rejected',
  GuaranteeApproved = 'guarantee:approved',
  GuaranteeApproving = 'guarantee:approving',
  GuaranteeRejected = 'guarantee:rejected',
  WarrantyApproved = 'warranty:approved',
}

export enum YieldFileState {
  Pending = 'pending',
  Processing = 'processing',
  Ok = 'ok',
  Failed = 'failed'
}

export enum YieldFileType {
  GuaranteePvSystData = 'guarantee:pvsyst-data',
  GuaranteePvSystReport = 'guarantee:pvsyst-report',
  GuaranteeCalculationSummary = 'guarantee:calculations',
  GuaranteeAssumptionsReport = 'guarantee:assumptions',

  ConsumptionPvSystReport = 'consumption:pvsyst-report',
  ConsumptionCalculationSummary = 'consumption:calculations',
  ConsumptionAssumptionsReport = 'consumption:assumptions',

  WarrantyExitDraw = 'warranty:exit-draw'
}

export enum YieldAction {
  GuaranteeApproval = 'guarantee:approval',
  GuaranteeRejection = 'guarantee:rejection',
  WarrantyApproval = 'warranty:approval',
  WarrantyRejection = 'warranty:rejection',
  ConsumptionApproval = 'consumption:approval',
  ConsumptionRejection = 'consumption:rejection',
}

export enum AssetDeliveryStatus {
  SetupIncomplete = 'SetupIncomplete',
  Operational = 'Operational',
  PendingDelivery = 'PendingDelivery'
}

export enum AssetType {
  Solar = 'SolarPvSystem',
  Generator = 'Generator',
}
